import script from "./ResumeList.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeList.vue?vue&type=script&setup=true&lang=js"

import "./ResumeList.vue?vue&type=style&index=0&id=173cb185&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173cb185"]])

export default __exports__